import React from 'react';
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import { UiKit } from 'components';
import * as UPS from './UPS';
import { isLabelTypeConfigurable } from '../methods';

const COMPONENT = {
  UPS_PAPERLESS: UPS.Paperless,
  UPS_NO_BOX_NO_LABEL: UPS.NoBoxNoLabel
};

export default function LabelTypes({
  types = [],
  data = {},
  onChange = () => {},
  isDisabled = false
}) {
  const options = _isArray(types) ? types : [];
  const labelTypes = _get(data, 'labelTypes', {});

  const onUpdate = (type = '', updates = {}, runValidation = true) => {
    onChange(
      {
        ...data,
        labelTypes: {
          ...data.labelTypes,
          [type]: { ...data.labelTypes[type], ...updates }
        }
      },
      runValidation
    );
  };

  const list = options.reduce((acc, info) => {
    const type = _get(info, 'type', '');
    const slug = _get(info, 'slug', '');

    const value = _get(labelTypes, type, {});
    const isConfigurable = isLabelTypeConfigurable(type);

    const Config = isConfigurable && COMPONENT[slug];

    if (Config) {
      acc.push(
        <div key={slug} className={styles.config}>
          <Config value={value} onChange={onUpdate} isDisabled={isDisabled} />
        </div>
      );
    }

    return acc;
  }, []);

  if (_isEmpty(list)) return null;

  return (
    <UiKit.Grid templateColumns="1fr" gap={16}>
      <UiKit.Grid templateColumns="1fr">
        <div className={styles.title}>Shipping Label options</div>
        <p className={styles.description}>
          Shopper will be offered the enabled shipping label options along with{' '}
          <em>Printable Label</em> option.
        </p>
      </UiKit.Grid>
      <UiKit.Grid templateColumns="1fr" gap={16}>
        {list}
      </UiKit.Grid>
    </UiKit.Grid>
  );
}
